<template>
  <div>
    <div v-for="(c, i) in list" :key="c.Id" class="card_item">
      <div class="flex_box">
        <div class="flex-box-title">
          <div class="flex-box-label__open">已预约</div>
          <p>{{ c.labName }}</p>
        </div>
      </div>
      <div class="sub-project">
        开放项目:{{ c.labTypeName }}
      </div>
      <div class="labj-content">
        <div class="content" :style="{height: !c.expand ? '25px': 'auto'}">
          <div class="subrec-time" v-for="(cc,ci) in c.openApplyPeriods" :key="ci">
            <div class="time-pic"></div>
            <span>预约时间:</span>
            <span>{{ cc.day }} {{cc.weekNum}}周  周{{ cc.weekDay }} {{cc.ptName?'('+cc.ptName +')':''}}</span>
          </div>
        </div>
        <div :class="c.expand ? 'expand' : 'not-expand'" @click="toggleExpand(c.id)" v-if="c.openApplyPeriods && c.openApplyPeriods.length > 1"></div>
      </div>
    </div>
    <!-- <el-card class="box-card" v-for="(c,i) in list" :key="c.id" style="margin-bottom: 15px">
      <div slot="header" class="clearfix" style="padding: 14px 20px">
        <div class="tag" v-if="c.status!='-2'">已预约</div>
        <div class="tag1" v-else>已取消</div>
        <p class="title">{{ c.labName }}</p>
        <div>
            <span>开放项目： {{ c.labTypeName }}</span>
        </div>
        <div class="flex_box">
            <span>预约时间： </span>
            <div style="margin-left: 3px">
            <p v-for="(cc,ci) in c.openApplyPeriods" :key="ci"><span>{{ cc.day }} {{cc.weekNum}}周  周{{ cc.weekDay }} {{cc.ptName?'（'+cc.ptName +'）':''}}</span></p>
            </div>
        </div>
      </div>
      <div v-if="c.status!='-2'">
      <p style="color: #777777;text-align: center;font-size: 18px;" @click="canlApply(c)">取消预约</p>
      </div>
    </el-card> -->
  </div>
</template>
<script>
export default {
    props: {
      list: {
        list: Array,
        default: []
      },
    },
    data(){
      return {}
    },
    methods: {
      toggleExpand(id){
        this.$emit('toggleExpand', id)
      },
    },
    mounted() {
        
    }
}
</script>
<style scoped>
  .time-pic {
    width:15px;
    height:15px;
    background: url("../../../assets/apply/timepic.png") no-repeat center;
  }
  .expand {
    position: absolute;
    width:15px;
    height:20px;
    top:5px;
    right:10px;
    background: url("../../../assets/apply/expand.png") no-repeat center;
  }
  .not-expand {
    position: absolute;
    width:15px;
    height:20px;
    top:5px;
    right:10px;
    background: url("../../../assets/apply/notexpand.png") no-repeat center;
  }
  .card_item {
    width: 100%;
    box-shadow: 0 1px 4px 0 #00000014;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    padding:15px;
    p{
      font-size: 16px;color: #333333;font-weight: 400;flex:1;
    }
  }
  .flex_box{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex_box .flex-box-title {
    display: flex;
    align-items: center;
  }
  .flex_box .flex-box-label__open {
    font-weight: normal;
    margin-right:10px;
    font-size: 12px;
    padding: 0 6px;
    line-height: 21px;
    background-color: #13499B;
    color: #ffffff;
  }
  .flex_box .flex-box-label__close {
    font-weight: normal;
    margin-right:10px;
    font-size: 12px;
    padding: 0 6px;
    line-height: 21px;
    background-color: #E8E9EA;
    color: #73767D;
  }
  .labj-content {
    position: relative;
    width:100%;
    padding: 5px 10px 0px 10px;
    background-color: #F6F8FB;
    margin-top:15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .labj-content .content {
    overflow: hidden;
    width:100%;
  }
  .labj-content .content .subrec-time {
    color: #8A9491;
    font-size:14px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    line-height:22px;
  }
  .sub-project {
    margin-top: 10px;
    color: #8A9491;
  }
</style>